import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { useTheme } from '../../../providers/theme';
import { useSMSignInUser } from '../machines/signInUser';
import toast from 'react-hot-toast';
import { vappContainer, VApplication } from '../../../application';
import {
  PageContainer,
  GoBackLink,
  Heading,
  Logo,
  FormComp,
  SubmitButton,
  OTPComp,
  ImageIcon,
  RoleComp,
  GoBackArrow,
  LoaderModal,
  PasswordUpdate,
} from '../components';
import { useSMSendOTP } from '../machines/sendOTP';
import { AppNavigatorService } from '@/AppNavigator';
import { SignInPageService } from '@/pages/SignIn';
import { USER_LEVEL } from '@/config/userManagement.config';
import styled from 'styled-components';
import { Loader } from '@/components';
import { StorageModule } from '@vlinder-web/storage-module-react';

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.displayName);
};

const loginPageServ = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
const ImgContainer = styled.div`
  width: 42%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    display: none;
  }
`;
const RightContainer = styled.div`
  width: 58%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 4%;
  padding-right: 4%;
  @media (max-width: 768px) {
    width: 92%;
  }
`;
const Container = styled.div`
  display: flex;
  // min-width: 90%;
  width: 70%;
  height: 70vh;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;
export const ContainerComm = (props: any) => {
  const { signInUserMachine, signInUserSend, signInUserState } =
    useSMSignInUser({});
  const { sendOTPSend } = useSMSendOTP({});
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const [whoAmI, setWhoAmI] = React.useState<string>('');
  const [email, setEmail] = React.useState<string>('');
  const [roles, setRoles] = React.useState<any>();
  const storageSrv = StorageModule.getInstance();
  const [passwordModal, setpasswordModal] = useState(false);
  const _sessionData = storageSrv.get('userProfile', 'session');
  // let invitemail =
  const getWhoAmI = async () => {
    const { whoami } = await loginPageServ()?.whoAmI();
    console.log('hifi->', whoami);
    setWhoAmI(whoami);
  };
  useEffect(() => {
    getWhoAmI();
  }, []);
  useEffect(() => {
    const data = {
      ...signInUserState?.event?.data?.value,
    };

    if (signInUserState?.matches('SIGN_IN_USER_SUCCESS') && data) {
      console.log(data);
      if (
        data?.userRoles[0]?.uuid === '2324e90f-6843-48e0-8f70-84ca5461a0de' ||
        _sessionData?.orgRole === 'ISSUER'
      ) {
        window.open(`/profile/my-profile`, '_self');
      } else if (
        USER_LEVEL.owner.includes(
          data?.currentRole ?? data?.userRoles?.[0]?.name
        )
      ) {
        window.open(`/profile/organization-profile`, '_self');
      } else {
        window.open(`/profile/my-profile`, '_self');
      }
    }
  }, [
    signInUserState?.matches('SIGN_IN_USER_SUCCESS') &&
      signInUserState?.event?.data?.value,
  ]);
  useEffect(() => {
    let token = loginPageServ()?.getToken();
    if (token) {
      if (whoAmI !== '') {
        console.log('whom->', whoAmI);
        if (
          USER_LEVEL.owner.includes(whoAmI) &&
          whoAmI !== 'issuer' &&
          _sessionData?.orgRole === 'ISSUER'
        ) {
          window.open(`/profile/organization-profile`, '_self');
        } else {
          window.open(`/profile/my-profile`, '_self');
        }
      }
    }
  }, [whoAmI]);

  const renderSubmitButton = () => {
    return <SubmitButton />;
  };

  const onIdentifierSubmit = (data: any) => {
    setRoles({});
    console.log(data);
    setEmail(data?.email);
    signInUserSend('VALIDATE_EMAIL', {
      payload: {
        email: data?.email,
      },
    });
  };

  const onIdentifierSubmitPassword = (data: any) => {
    signInUserSend('VALIDATE_PASSWORD', {
      payload: {
        email: email,
        password: data.password,
        rememberMe: data.rememberMe,
      },
    });
  };

  const onIdentifierSetPassword = (data: any) => {
    signInUserSend('SET_PASSWORD', {
      payload: {
        email: email,
        password: data.password,
      },
    });
  };

  const onOTPSubmit = (data: any) => {
    signInUserSend('RENDER_OTP', {
      payload: {
        email: email,
        otp: data.otp,
      },
    });
  };

  const onVerifyOTPSubmit = (data: any) => {
    console.log(data);
    signInUserSend('VERIFY_OTP', {
      payload: {
        email: email,
        otp: data.otp,
      },
    });
  };

  const _handleResendClick = (email: string) => {
    sendOTPSend('START', {
      payload: {
        email: email,
      },
    });
  };

  const onRoleSelect = (role: any) => {
    const { roleId, name, org, token } = role;
    console.log(roleId, name, org, token);
    let data = {};
    data = {
      jwtToken: token,
      role: roleId,
      name,
    };
    if (org) {
      data = { ...data, org: org };
    }

    signInUserSend('GET_ACCESS_TOKEN', {
      payload: { ...data },
    });
  };

  const onAddRole = () => {
    window.open(`/add-role`, '_self');
  };

  useEffect(() => {
    console.log(signInUserState);
    if (
      signInUserState?.event?.data?.type == 'EMAIL_VERIFIED' ||
      signInUserState?.event?.data?.type == 'EMAIL_NOT_VERIFIED'
    ) {
      console.log(signInUserState?.event?.data?.value);
      setRoles(signInUserState?.event?.data?.value);
    }
    // if (
    //   signInUserState?.matches('RENDER_ACCOUNT_SELECTION') &&
    //   signInUserState?.event?.data?.value
    // ) {
    //   setRoles(signInUserState?.event?.data?.value);
    // }

    if (
      signInUserState?.matches('VERIFY_OTP_FAILED') ||
      signInUserState?.matches('SET_PASSWORD_FAILED') ||
      signInUserState?.matches('VALIDATE_OTP_FAILED') ||
      signInUserState?.matches('GET_ACCESS_TOKEN_FAILED') ||
      signInUserState?.matches('SIGN_IN_USER_FAILED') ||
      signInUserState?.matches('RENDER_OTP')
    ) {
      signInUserSend('START');
    }
    if (
      signInUserState?.matches('VERIFY_OTP') ||
      signInUserState?.matches('RENDER_OTP')
    ) {
      sendOTPSend('START', {
        payload: {
          email: email,
        },
      });
    }
    if (signInUserState?.matches('RENDER_SIGNUP')) {
      // window.open(`/sign-up`, '_self');
      props?.onRedirectSignIn && props?.onRedirectSignIn(email);
    }
    if (signInUserState?.matches('REDIRECT_SIGNIN')) {
      window.open(`/sign-in`, '_self');
    }
    if (signInUserState?.matches('CHANGE_PASSWORD')) {
      setpasswordModal(true);
    }
    if (signInUserState?.matches('CHANGE_PASSWORD_FAILED')) {
      // toast.error('Password update failed');
      setpasswordModal(true); // allow retry
    }
  }, [signInUserState]);

  useEffect(() => {
    if (
      signInUserState?.matches('RENDER_ACCOUNT_SELECTION') &&
      !roles &&
      signInUserState?.context?.SIGN_IN_USER
    ) {
      setRoles(signInUserState?.context?.SIGN_IN_USER);
    }
  }, [signInUserState]);

  const _getSuccessNotification = () => {
    if (signInUserState?.matches('SIGN_IN_USER_SUCCESS')) {
      toast.success('Logged in successfully!');
    }
  };
  const _getErrorNotification = () => {
    // if (signInUserState?.matches('SIGN_IN_USER_FAILED')) {
    //   toast.error('Something went wrong!');
    // }
  };

  const renderValidatePassword = () => {
    console.log('here');
    return (
      <Container style={{ margin: 'auto' }}>
        <ImgContainer>
          <img
            src="https://i.ibb.co/CbVc1f2/Ministry-New-Logo-cropped-PNG-1.png"
            height="80%"
            width="80%"
          />
        </ImgContainer>
        <RightContainer>
          <div>
            <Heading
              title={staticPageContentConfig?.header?.identifier?.title}
            />
            <FormComp
              renderSubmitButton={renderSubmitButton}
              authType={'PASSWORD'}
              onFormSubmit={onIdentifierSubmitPassword}
              isPassword={true}
            />
          </div>
        </RightContainer>

        <GoBackLink />
      </Container>
    );
  };

  const renderRenderOTP = () => {
    console.log('here');
    return (
      <div>
        <GoBackLink />
        <Heading title={staticPageContentConfig?.header?.otp?.title} />
        <ImageIcon
          imageIconURL={staticPageContentConfig?.header?.otp?.iconURL}
          height={100}
        />
        <OTPComp
          renderSubmitButton={renderSubmitButton}
          onFormSubmit={onOTPSubmit}
          onResendClick={_handleResendClick.bind(null, email)}
        />
      </div>
    );
  };

  // Function for rendering VERIFY_OTP case
  const renderVerifyOTP = () => {
    console.log('here');
    return (
      <Container style={{ margin: 'auto' }}>
        <ImgContainer>
          <img
            src="https://i.ibb.co/CbVc1f2/Ministry-New-Logo-cropped-PNG-1.png"
            height="80%"
            width="80%"
          />
        </ImgContainer>
        <RightContainer>
          <div>
            <Heading
              title={staticPageContentConfig?.header?.identifier?.title}
            />
            <OTPComp
              renderSubmitButton={renderSubmitButton}
              onFormSubmit={onVerifyOTPSubmit}
              onResendClick={_handleResendClick.bind(null, email)}
            />
          </div>
        </RightContainer>

        <GoBackLink />
      </Container>
    );
  };

  // Function for rendering RENDER_ACCOUNT_SELECTION case
  const renderRenderAccountSelection = () => {
    console.log('here');
    // setpasswordModal(false);
    return (
      <Col lg={5} md={8} sm={12}>
        <Logo logoURL={staticPageContentConfig?.header?.identifier?.logo} />
        <GoBackArrow />
        <RoleComp
          {...signInUserState?.event?.data?.value}
          signInToken={roles?.signInToken ?? roles?.accessToken}
          current={props?.whoami}
          onRoleSelect={onRoleSelect}
          onAddRole={onAddRole}
          allUserRolesList={roles?.orgRolesfor}
        />
      </Col>
    );
  };
  const changePasswordForm = (formData: any) => {
    setpasswordModal(false);
    console.log('roles=============', roles);
    signInUserSend('CHANGE_PASSWORD', {
      payload: {
        ...formData,
        token: roles?.accessToken,
      },
    });
  };

  const renderPasswordModal = () => {
    if (passwordModal)
      return (
        <PasswordUpdate
          showModal={passwordModal}
          submitButtonLabel={'Update'}
          handleClose={() => {
            setpasswordModal(false);
          }}
          onFormSubmit={changePasswordForm}
        />
      );
  };

  // Function for rendering SET_PASSWORD case
  const renderSetPassword = () => {
    console.log('here');
    return (
      <Container style={{ margin: 'auto' }}>
        <ImgContainer>
          <img
            src="https://i.ibb.co/CbVc1f2/Ministry-New-Logo-cropped-PNG-1.png"
            height="80%"
            width="80%"
          />
        </ImgContainer>
        <RightContainer>
          <div>
            <Heading
              title={staticPageContentConfig?.header?.identifier?.title}
            />
            <FormComp
              renderSubmitButton={renderSubmitButton}
              authType={'PASSWORD'}
              onFormSubmit={onIdentifierSetPassword}
              isSetPassword={true}
            />
          </div>
        </RightContainer>

        <GoBackLink />
      </Container>
    );
  };

  // Function for rendering the default case (email collection)
  const renderEmailCollection = () => {
    console.log('here');
    return (
      <Container style={{ margin: 'auto' }}>
        <ImgContainer>
          <img
            src="https://i.ibb.co/CbVc1f2/Ministry-New-Logo-cropped-PNG-1.png"
            height="80%"
            width="80%"
          />
        </ImgContainer>
        <RightContainer>
          <div>
            <Heading
              title={staticPageContentConfig?.header?.identifier?.title}
            />
            <FormComp
              renderSubmitButton={renderSubmitButton}
              authType={'PASSWORD'}
              onFormSubmit={onIdentifierSubmit}
              isEmail={true}
            />
          </div>
        </RightContainer>

        <GoBackLink />
      </Container>
    );
  };

  const _renderPage = () => {
    if (signInUserState?.matches('VALIDATE_PASSWORD')) {
      return renderValidatePassword();
    } else if (
      signInUserState?.matches('RENDER_OTP') ||
      signInUserState?.matches('VALIDATE_OTP_FAILED')
    ) {
      return renderRenderOTP();
    } else if (
      signInUserState?.matches('VERIFY_OTP') ||
      signInUserState?.matches('VERIFY_OTP_FAILED')
    ) {
      return renderVerifyOTP();
    } else if (signInUserState?.matches('RENDER_ACCOUNT_SELECTION')) {
      return renderRenderAccountSelection();
    } else if (signInUserState?.matches('SET_PASSWORD')) {
      return renderSetPassword();
    } else if (signInUserState?.matches('VALIDATE_EMAIL')) {
      return renderEmailCollection();
    } else if (
      signInUserState?.matches('CHANGE_PASSWORD') ||
      signInUserState?.matches('CHANGE_PASSWORD_FAILED')
    ) {
      return renderPasswordModal();
    } else {
      return (
        <Loader {...(staticPageContentConfig?.loading?.GetPageLoading || {})} />
      );
    }
  };
  return (
    <PageContainer>
      {_getSuccessNotification()}
      {_getErrorNotification()}
      {/* {_getPageLoading()} */}
      {_renderPage()}
    </PageContainer>
  );
};
